
/* injects from baggage-loader */

'use strict';

import ProjectInvestmentWizardStep1Component from './projectinvestmentwizard.step1.component';

const ProjectInvestmentWizardStep1PageModule = angular.module('project-investment-wizard-step-1-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('projectinvestmentwizard.start', {
        url: '/start',
        component: 'projectInvestmentWizardStep1',
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('projectInvestmentWizardStep1', new ProjectInvestmentWizardStep1Component());

export default ProjectInvestmentWizardStep1PageModule;



// WEBPACK FOOTER //
// ./src/app/pages/projectInvestmentWizard/step1/projectinvestmentwizard.step1.module.js